import { useState } from "react";
const useGridPaging = ({
  paginationMode,
  sortingMode,
  page,
  pageSize,
  rowCount,
  rowsPerPageOptions,
  rows,
  onPageChange,
  onPageSizeChange
}) => {
  const isServer = paginationMode === "server" || sortingMode === "server";
  const gridRowCount = rowCount ?? rows?.length;
  let gridPage = 0;
  if (page > -1) {
    gridPage = isServer ? gridRowCount > 0 ? page - 1 : 0 : page;
  }
  const gridPageSize = pageSize ?? (rowsPerPageOptions?.length > 0 ? rowsPerPageOptions[0] : 10);
  const pageCount = Math.ceil(gridRowCount / gridPageSize);
  const [internalPage, setInternalPage] = useState(gridPage ?? 0);
  const [internalPageSize, setInternalPageSize] = useState(gridPageSize ?? 10);
  const handlePageChange = (newPage) => {
    if (onPageChange) {
      onPageChange({ page: isServer ? newPage + 1 : newPage, pageCount, pageSize, paginationMode, rowCount: gridRowCount });
    }
    setInternalPage(newPage);
  };
  const handlePageSizeChange = (newPageSize) => {
    if (onPageSizeChange) {
      onPageSizeChange({ page, pageCount, pageSize: newPageSize, paginationMode, rowCount: gridRowCount });
    }
    if (!isServer) {
      const lastPage = Math.ceil(rowCount / newPageSize) - 1;
      if (internalPage > lastPage) {
        setInternalPage(lastPage);
      }
    }
    setInternalPageSize(newPageSize);
  };
  return {
    page: isServer ? gridPage : internalPage,
    pageSize: isServer ? gridPageSize : internalPageSize,
    paginationMode: paginationMode ?? sortingMode ?? "client",
    pageCount,
    rowCount: gridRowCount,
    onPageChange: handlePageChange,
    onPageSizeChange: handlePageSizeChange
  };
};
export {
  useGridPaging
};
//# sourceMappingURL=useGridPaging.js.map
